import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { NgModule } from '@angular/core';
// import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CodeInputModule } from 'angular-code-input';
import { NouisliderModule } from 'ng2-nouislider';
import { ImageCropperModule } from 'ngx-image-cropper';
import { QuillModule } from 'ngx-quill';
import { MaterialModule } from '../material/material.module';
import { ActionableDialogComponent } from './actionable-dialog/actionable-dialog.component';
import { ApplicationActivityComponent } from './application/application-activity/application-activity.component';
import { ApplicationChecklistComponent } from './application/application-checklist/application-checklist.component';
import { ApplicationInformationComponent } from './application/application-information/application-information.component';
import { ApplicationMessageInputComponent } from './application/application-message-input/application-message-input.component';
import { ApplicationMessageComponent } from './application/application-message/application-message.component';
import { ApplicationStatusModalComponent } from './application/application-status-modal/application-status-modal.component';
import { BaseFooterComponent } from './base-footer/base-footer.component';
import { BaseSidebarMenuComponent } from './base-sidebar/base-sidebar-menu/base-sidebar-menu.component';
import { BaseSidebarNavitemComponent } from './base-sidebar/base-sidebar-navitem/base-sidebar-navitem.component';
import { BaseSidebarReferralBlockComponent } from './base-sidebar/base-sidebar-referral-block/base-sidebar-referral-block.component';
import { BaseSidebarComponent } from './base-sidebar/base-sidebar.component';
import { BaseTopbarDropdownComponent } from './base-topbar/base-topbar-dropdown/base-topbar-dropdown.component';
import { BaseTopbarMenuComponent } from './base-topbar/base-topbar-menu/base-topbar-menu.component';
import { BaseTopbarNavitemComponent } from './base-topbar/base-topbar-navitem/base-topbar-navitem.component';
import { BaseTopbarComponent } from './base-topbar/base-topbar.component';
import { CgMenuComponent } from './cg-menu/cg-menu.component';
import { CgNavigatorComponent } from './cg-navigator/cg-navigator.component';
import { CreateStudentModalComponent } from './create-student-modal/create-student-modal.component';
import { CropImageDialogComponent } from './crop-image-dialog/crop-image-dialog.component';
import { CurrencySelectorComponent } from './currency-selector/currency-selector.component';
import { CounsellorProfileDrawerComponent } from './counsellor-profile-drawer/counsellor-profile-drawer.component';
import { CounsellorReviewDialogComponent } from './counsellor-review-dialog/counsellor-review-dialog.component';
import { SideDrawerComponent } from './side-drawer/side-drawer.component';
import { StudentProfileDrawerComponent } from './student-profile-drawer/student-profile-drawer.component';
import { SessionReportDialogComponent } from './session-report-dialog/session-report-dialog.component';
import { ProfileSessionListComponent } from './profile-session-list/profile-session-list.component';
import { PresignedImageComponent } from './presigned-image/presigned-image.component';
import { CustomNotificationSnackbarComponent } from './custom-notification-snackbar/custom-notification-snackbar.component';
import { MatButtonLoadingDirective } from './directive/mat-button-loading.directive';
import { EditDeleteDialogComponent } from './edit-delete-dialog/edit-delete-dialog.component';
import { EmailValidationComponent } from './email-validation/email-validation.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { FooterLinkDialogComponent } from './footer-link-dialog/footer-link-dialog.component';
import { FooterComponent } from './footer/footer.component';
import { GradeInputComponent } from './grade-input/grade-input.component';
import { HeaderComponent } from './header/header.component';
import { ModalDialogComponent } from './modal-dialog/modal-dialog.component';
import { MultiselectDropdownComponent } from './multiselect-dropdown/multiselect-dropdown.component';
import { PavePageLoaderComponent } from './pave-page-loader/pave-page-loader.component';
import { PaveRadioCardComponent } from './pave-radio-card/pave-radio-card.component';
import { CurrencyViewPipe } from './pipe/currency-view.pipe';
import { FilterPipe } from './pipe/filter.pipe';
import { OrderByPipe } from './pipe/order-by.pipe';
import { PresignedViewPipe } from './pipe/presigned-view.pipe';
import { RadioDialogComponent } from './radio-dialog/radio-dialog.component';
import { ReferDialogComponent } from './refer-dialog/refer-dialog.component';
import { ApplicationEmptyIntakeDialogComponent } from './results/application-empty-intake-dialog/application-empty-intake-dialog.component';
import { ApplicationIntakeDialogComponent } from './results/application-intake-dialog/application-intake-dialog.component';
import { ApplicationSuccessDialogComponent } from './results/application-success-dialog/application-success-dialog.component';
import { CourseResultRowComponent } from './results/course-result-row/course-result-row.component';
import { FilterComponent } from './results/filter/filter.component';
import { ReminderCardComponent } from './results/reminder-card/reminder-card.component';
import { ResultsComponent } from './results/results.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { SearchDialogComponent } from './search-dialog/search-dialog.component';
import { SearchPreviewCardComponent } from './search-preview-card/search-preview-card.component';
import { AcademicComponent } from './student-profile/academic/academic.component';
import { EditLanguageCertificationComponent } from './student-profile/academic/edit-language-certification/edit-language-certification.component';
import { EditOtherCertificationComponent } from './student-profile/academic/edit-other-certification/edit-other-certification.component';
import { EditQualificationRowComponent } from './student-profile/academic/edit-qualification-row/edit-qualification-row.component';
import { QualificationRowComponent } from './student-profile/academic/qualification-row/qualification-row.component';
import { DocumentsComponent } from './student-profile/documents/documents.component';
import { UploadDialogComponent } from './student-profile/documents/upload-dialog/upload-dialog.component';
import { EditVisaRefusalComponent } from './student-profile/personal/edit-visa-refusal/edit-visa-refusal.component';
import { PersonalComponent } from './student-profile/personal/personal.component';
import { ProfileSidebarComponent } from './student-profile/profile-sidebar/profile-sidebar.component';
import { ProfileComponent } from './student-profile/profile.component';
import { StudySearchInputComponent } from './study-search-input/study-search-input.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { UploadRowComponent } from './upload-row/upload-row.component';
import { UserInfoCaptureComponent } from './user-info-capture/user-info-capture.component';

@NgModule({
  declarations: [
    SearchBarComponent,
    UploadRowComponent,
    OrderByPipe,
    FilterPipe,
    CurrencyViewPipe,
    ActionableDialogComponent,
    PresignedViewPipe,
    CurrencySelectorComponent,
    RadioDialogComponent,
    MatButtonLoadingDirective,
    FeedbackComponent,
    CropImageDialogComponent,
    GradeInputComponent,
    ResultsComponent,
    CourseResultRowComponent,
    FilterComponent,
    HeaderComponent,
    FooterComponent,
    UserInfoCaptureComponent,
    CgNavigatorComponent,
    CgMenuComponent,
    EditDeleteDialogComponent,
    CustomNotificationSnackbarComponent,
    ReferDialogComponent,
    MultiselectDropdownComponent,
    TextEditorComponent,
    AcademicComponent,
    DocumentsComponent,
    PersonalComponent,
    ProfileSidebarComponent,
    ProfileComponent,
    QualificationRowComponent,
    EditVisaRefusalComponent,
    EditQualificationRowComponent,
    EditLanguageCertificationComponent,
    EditOtherCertificationComponent,
    UploadDialogComponent,
    CreateStudentModalComponent,
    ModalDialogComponent,
    PavePageLoaderComponent,
    ApplicationIntakeDialogComponent,
    PaveRadioCardComponent,
    ReminderCardComponent,
    ApplicationSuccessDialogComponent,
    ApplicationEmptyIntakeDialogComponent,
    ApplicationActivityComponent,
    ApplicationMessageInputComponent,
    ApplicationInformationComponent,
    ApplicationChecklistComponent,
    ApplicationMessageComponent,
    ApplicationStatusModalComponent,
    StudySearchInputComponent,
    SearchPreviewCardComponent,
    SearchDialogComponent,
    FooterLinkDialogComponent,
    BaseTopbarComponent,
    BaseFooterComponent,
    BaseTopbarNavitemComponent,
    BaseTopbarMenuComponent,
    BaseSidebarComponent,
    BaseSidebarNavitemComponent,
    BaseSidebarReferralBlockComponent,
    BaseSidebarMenuComponent,
    BaseTopbarDropdownComponent,
    EmailValidationComponent,
    CounsellorProfileDrawerComponent,
    CounsellorReviewDialogComponent,
    SideDrawerComponent,
    StudentProfileDrawerComponent,
    SessionReportDialogComponent,
    ProfileSessionListComponent,
    PresignedImageComponent,
  ],
  imports: [
    CommonModule,
    A11yModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    ImageCropperModule,
    RouterModule,
    NouisliderModule,
    FormsModule,
    CodeInputModule,
    QuillModule.forRoot(),
  ],
  exports: [
    SearchBarComponent,
    UploadRowComponent,
    CurrencySelectorComponent,
    CropImageDialogComponent,
    OrderByPipe,
    FilterPipe,
    CurrencyViewPipe,
    PresignedViewPipe,
    MatButtonLoadingDirective,
    GradeInputComponent,
    ResultsComponent,
    FilterComponent,
    HeaderComponent,
    UserInfoCaptureComponent,
    CgMenuComponent,
    CgNavigatorComponent,
    MultiselectDropdownComponent,
    QuillModule,
    TextEditorComponent,
    ModalDialogComponent,
    PavePageLoaderComponent,
    ApplicationActivityComponent,
    ApplicationMessageInputComponent,
    ApplicationInformationComponent,
    ApplicationChecklistComponent,
    StudySearchInputComponent,
    SearchPreviewCardComponent,
    SearchDialogComponent,
    BaseTopbarComponent,
    BaseFooterComponent,
    BaseTopbarNavitemComponent,
    BaseTopbarMenuComponent,
    BaseSidebarComponent,
    BaseSidebarNavitemComponent,
    BaseSidebarReferralBlockComponent,
    BaseSidebarMenuComponent,
    BaseTopbarDropdownComponent,
    EmailValidationComponent,
    CounsellorProfileDrawerComponent,
    SideDrawerComponent,
    StudentProfileDrawerComponent,
    ProfileSessionListComponent,
    PresignedImageComponent,
  ],
  providers: [
    CurrencyViewPipe,
    AcademicComponent,
    DocumentsComponent,
    PersonalComponent,
    ProfileComponent,
    ProfileSidebarComponent,
  ],
})
export class SharedModule {}
